import React, {useState} from 'react';
import { Form, Row, Col, Modal} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from 'react-icons/fa';
import {validateFormFields} from '../../utils';

const DashboardSearchModal = ({onModalClose, handleSearch}) => {
    const initialObj = JSON.parse(sessionStorage.getItem('user'));
    const [formErrors, setFormErrors] = useState({});
    const fromDate = new Date();
    fromDate.setMonth(fromDate.getMonth() - 12);

    const defaultToDate = new Date();
    const defaultFromDate = fromDate;

    const [searchObj, setSearchObj] = useState({
      issueName: '',
      issuerName: initialObj && initialObj.issuerName,
      endDate: defaultToDate,
      beginDate: defaultFromDate,
      retiredFlag: 'N'
    })

    const handleChange = (e, k) => {
      if(k === 'issueName') {
        setSearchObj({...searchObj, [k] : e.target.value })
      } else if (k === "retiredFlag") {
        const val =  e.target.checked ? 'N' : 'Y';
        setSearchObj({...searchObj, [k] : val })
      } else {
        setSearchObj({...searchObj, [k] : e })
      }
    }

    const handleSubmit = (e) => {
      const form = e.target.closest('form#search-modal');
      let formErrors = validateFormFields(form.elements);
      if(Object.keys(formErrors).length > 0) {
        setFormErrors(formErrors);
      } else {
        handleSearch({...searchObj});
      }
    }

    return (
      <Modal show={true} onHide={onModalClose} backdrop="static" keyboard={false}  size="lg">
      <Modal.Header closeButton>Search Criteria</Modal.Header>
      <Modal.Body>
        <form id="search-modal">
          <div className="control">
            <label>Issue Name Contains:</label>
            <input type="text" value={searchObj.issueName} onChange={(e)=>handleChange(e, 'issueName')}/>
          </div>
          <div className="control">
            <label>Issuer Name Contains:</label>
            <input type="text" value={searchObj.issuerName} disabled/>
          </div>
          <div className="">
            <label>Sale Date Range: </label>
            <Row>
              <Col md={6} className="control"><span className="required"> * </span> From
              <span>
                <DatePicker 
                key="1"
                selected={searchObj.beginDate}
                dateFormat="M/d/yyyy" 
                maxDate= {new Date(9999, 12, 31)}
                onChange={(e)=>handleChange(e, 'beginDate')} />
                <FaCalendarAlt className="date-picker-icon"/>
              </span>
              <input type="hidden" data-validations={["required"]}  value={searchObj.beginDate ? new Date(searchObj.beginDate) : ""} name="beginDate" />    
              { formErrors && formErrors['beginDate'] && <p className="error">{ formErrors['beginDate'] }</p>}
              </Col>

              <Col md={6} className="control"><span className="required"> * </span> To
              <span>
                <DatePicker 
                key="2"
                selected={searchObj.endDate}
                onChange={(e)=>handleChange(e, "endDate")}
                dateFormat="M/d/yyyy" 
                maxDate= {new Date(9999, 12, 31)} />
                <FaCalendarAlt className="date-picker-icon"/>
              </span>
              <input type="hidden" data-validations={["required"]}  value={searchObj.endDate ? new Date(searchObj.endDate) : ""} name="endDate" />    
              { formErrors && formErrors['endDate'] && <p className="error">{ formErrors['endDate'] }</p>}
              </Col>
            </Row>
          </div>
          <div>
            <Form.Check inline type="checkbox" id="retiredFlag" label="Ongoing Reportable?" checked={searchObj.retiredFlag === 'N'} onChange={(e)=>handleChange(e, 'retiredFlag')} />
          </div>
          <div>
            <button type="button" className="link-button" >Clear Search </button>
          </div>

          <Modal.Footer>
          <button type="button" className="custom-button-secondary btn-secondary" onClick={()=>onModalClose()}>Cancel</button>{" "}
          <button className="fright custom-button" type="button" onClick={(e)=>handleSubmit(e)}>Search</button>
          </Modal.Footer>

          </form>
          </Modal.Body>

          
        </Modal>
    )
}

export default DashboardSearchModal
